import { NavigationMockApi } from 'app/core/shared/mock-api/common/navigation/api';
import { NotificationsMockApi } from 'app/core/shared/mock-api/common/notifications/api';
import { ShortcutsMockApi } from 'app/core/shared/mock-api/common/shortcuts/api';
import { SharedMockApi } from 'app/core/shared/mock-api/_shared-api.mock';


import { CompanyFacilitiesMockApi } from 'app/core/shared/mock-api/data-management/_company-facilities.api';
import { CompanyContractsMockApi } from 'app/core/shared/mock-api/data-management/_company-contracts.api';
import { CompanySitesSubsitesMockApi } from 'app/core/shared/mock-api/data-management/_company-sites-subsites.api';
import { CompanyWellWellboreWellboreStringMockApi } from 'app/core/shared/mock-api/data-management/_company-well-wellbore-wellboreString.api';
import { MetadataServiceTypesMockApi } from 'app/core/shared/mock-api/configurations/_metadata-service-types.api';
import { MetadataFacilityTypesMockApi } from 'app/core/shared/mock-api/configurations/_metadata-facility-types.api';
import { MetadataPlatformTypesMockApi } from 'app/core/shared/mock-api/configurations/_metadata-platform-types.api';
import { MetadataOperationalMockApi } from 'app/core/shared/mock-api/configurations/_metadata-operational.api';
import { MetadataUtilizationCategoriesMockApi } from 'app/core/shared/mock-api/configurations/_metadata-utilization-categories.api';
import { MetadataLocationSublocationMockApi } from 'app/core/shared/mock-api/configurations/_metadata-location-sublocation.api';
import { MetadataUnitDimensionsMockApi } from 'app/core/shared/mock-api/configurations/_metadata-unit-dimensions.api';
import { MetadataWellTypesMockApi } from 'app/core/shared/mock-api/configurations/_metadata-well-types.api';
import { MetadataEquipmentCategoriesMockApi } from 'app/core/shared/mock-api/configurations/_metadata-equipment-categories.api';
import { MetadataPceMockApi } from 'app/core/shared/mock-api/configurations/_metadata-pce.api';
import { MetadataDownholeCategoriesMockApi } from 'app/core/shared/mock-api/configurations/_metadata-downhole-categories.api';
import { WsoProjectMockApi } from 'app/core/shared/mock-api/business-process/_wso-project.api';

export const mockApiServices = [
    NavigationMockApi,
    NotificationsMockApi,
    ShortcutsMockApi,
    SharedMockApi,

    // NavigationMockApi,
    // NotificationsMockApi,
    // ShortcutsMockApi,
    // MembersMockApi,
    // CompanyFacilitiesMockApi,
    // CompanyContractsMockApi,
    // CompanySitesSubsitesMockApi,
    // CompanyWellWellboreWellboreStringMockApi,
    // MetadataServiceTypesMockApi,
    // MetadataFacilityTypesMockApi,
    // MetadataPlatformTypesMockApi,
    // MetadataOperationalMockApi,
    // MetadataUtilizationCategoriesMockApi,
    // MetadataLocationSublocationMockApi,
    // MetadataUnitDimensionsMockApi,
    // MetadataWellTypesMockApi,
    // MetadataEquipmentCategoriesMockApi,
    // MetadataPceMockApi,
    // MetadataDownholeCategoriesMockApi,
    // WsoProjectMockApi
];
